import { BlogPost } from '../blog';

import { BetaPost } from './post';

export default function Post() {
  const beta = BetaPost();

  return <BlogPost {...beta} />;
}
